import {ChangeDetectionStrategy, Component, computed, inject, signal} from '@angular/core';
import {ElementToggleEnum} from '../../../../../../enums/CssClassEnums';
import {WindowSizeService} from '../../../../../../services/window-size.service';

@Component({
  selector: 'app-search-content-ad-v2',
  templateUrl: './search-content-ad-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchContentAdV2Component {
  public windowSizeService = inject(WindowSizeService);
  public size = this.windowSizeService.windowSize;
  public isDesktopAdVisible = computed<boolean>(() => this.size()[0] >= 576);
  public isMobileAdVisible = computed<boolean>(() => this.size()[0] < 576);
  public adContainerCssClass = signal<string>(ElementToggleEnum.HIDDEN);

  public onBannerReload: Function = (cssClass: string) => {
    this.adContainerCssClass.set(cssClass);
  };
}
